module.exports = __webpack_public_path__ + "img/Kathryn.b827dabf.png";